import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'revamp/reusable-components/tooltip/tooltip'
import Info from '@/assets/common/info.inline.svg'
import Text from '@/stories/components/Common/NewText'

type TUSL2WidgetHeadingProps = {
  children?: string
  tooltip?: string
  subheading?: string
}

export function USL2WidgetHeading(props: TUSL2WidgetHeadingProps) {
  const { children, tooltip, subheading } = props

  if (!children) return null

  return (
    <div className="border-b-1 border-grey-tertiary mb-6 flex justify-between pb-2.5 lg:pb-6">
      <div>
        <Text appearance="heading2" tag="h2">
          {children}
        </Text>
        {subheading && (
          <Text appearance="body1" addClassName="text-grey">
            {subheading}
          </Text>
        )}
      </div>
      {tooltip && (
        <Tooltip>
          <TooltipTrigger>
            <Info className="h-4 w-4" />
          </TooltipTrigger>

          <TooltipContent>
            <div
              className="bg-ind-white border-grey-light min-w-52 max-w-xs rounded-xl border-[0.5px] p-4 text-[11px] leading-4"
              dangerouslySetInnerHTML={{
                __html: tooltip,
              }}
            />
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}
